import React from "react";
import "../Assets/css/carousel.css";
const Carousel = () => {
  return (
    <div className="mainView">
      {/* heading */}
      <div className="header">
        <h1>Gallery</h1>
      </div>

      <section>
        <div className="wrapper">
          <img src="https://picsum.photos/seed/picsum1/300/300" />
          <img src="https://picsum.photos/seed/picsum2/300/300" />
          <img src="https://picsum.photos/seed/picsum3/300/300" />
          <img src="https://picsum.photos/seed/picsum4/300/300" />
          <img src="https://picsum.photos/seed/picsum5/300/300" />
          <img src="https://picsum.photos/seed/picsum6/300/300" />
          <img src="https://picsum.photos/seed/picsum7/300/300" />
          <img src="https://picsum.photos/seed/picsum8/300/300" />
          <img src="https://picsum.photos/seed/picsum9/300/300" />
          <img src="https://picsum.photos/seed/picsum10/300/300" />
          <img src="https://picsum.photos/seed/picsum11/300/300" />
          <img src="https://picsum.photos/seed/picsum12/300/300" />
          <img src="https://picsum.photos/seed/picsum13/300/300" />
          <img src="https://picsum.photos/seed/picsum14/300/300" />
          <img src="https://picsum.photos/seed/picsum15/300/300" />
          <img src="https://picsum.photos/seed/picsum16/300/300" />
        </div>
      </section>
    </div>
  );
};
export default Carousel;
